import { FC, useRef } from 'react'

import { useParams } from '@tanstack/react-router'

import { Button, Cluster, Spinner, Stack } from '@forto-dev/phoenix-ui-core'
import { Notifications, NotificationsHeader, NotificationsList } from '@forto-dev/phoenix-ui-core/ship'

import { NotificationItem } from '@/features/notifications/list/notificationItem'
import { useLoadMoreOnScroll } from '@/utils/hooks/useLoadMoreOnScroll'

import { NotificationsFilters } from './filters'
import { NotificationsQuickFilters } from './quickFilters'
import { NotificationsSorting } from './sorting'
import { useNotificationCenterSearch } from '../hooks/useNotificationCenterSearch'
import { useNotifications } from '../hooks/useNotifications'

export const NotificationsSidebar: FC = () => {
  const { id } = useParams({ strict: false })

  return <LeanNotificationsSidebar id={id} />
}
export const LeanNotificationsSidebar: FC<{ id?: string }> = ({ id }) => {
  const { search } = useNotificationCenterSearch()
  const {
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    items: notifications,
  } = useNotifications({
    type: search.type,
    status: search.status,
    startDate: search.durationFrom,
    endDate: search.durationTo,
  })
  const observedButtonRef = useRef<HTMLButtonElement | null>(null)

  useLoadMoreOnScroll(observedButtonRef, fetchNextPage, hasNextPage, isFetchingNextPage)

  return (
    <Notifications>
      <NotificationsHeader>
        <Stack gap={12}>
          <Stack gap={8}>
            <NotificationsSorting />
            <NotificationsFilters />
          </Stack>
          <NotificationsQuickFilters />
        </Stack>
      </NotificationsHeader>
      <NotificationsList scrollable>
        {(notifications ?? []).map((notification) => {
          return <NotificationItem notification={notification} selectedID={id} key={notification.id} />
        })}
        {hasNextPage ? (
          <Stack x="center" gap={24}>
            <Button ref={observedButtonRef} variant="ghost">
              {isFetchingNextPage ? (
                <Cluster gap={8} y="center">
                  <Spinner size="xs" />
                </Cluster>
              ) : (
                '…'
              )}
            </Button>
          </Stack>
        ) : null}
      </NotificationsList>
    </Notifications>
  )
}
